import { BoxProgrammingHeader } from "@/modules/boxProgrammation/components/boxProgrammingHeader/boxProgrammingHeader"
import { BoxProgramTemplateCalendar } from "@/modules/boxProgrammation/components/boxProgramTemplateCalendar"
import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { CalendarProvider } from "@modules/calendar/context/calendarContext"
import dayjs from "dayjs"
import { Suspense } from "react"

export function BoxProgrammationTemplatePage({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <CalendarProvider
      initialDate={dayjs().startOf("day")}
      defaultDisplayDetailedEvents={false}
      defaultView="dayGridWeek"
      isWeekTemplate={true}
      hasHours={true}
    >
      <div
        className={cn(
          "flex h-full w-full min-w-280 flex-col gap-10 px-6 py-6 lg:mx-auto 2xl:w-8/10 2xl:px-0",
          className,
        )}
        {...props}
      >
        <BoxProgrammingHeader />
        <Suspense fallback={<LoadingSpinner />}>
          <BoxProgramTemplateCalendar />
        </Suspense>
      </div>
    </CalendarProvider>
  )
}
